import { EVENT_SET_QUICK_SEARCH_VALUE, publishEvent } from "../utils/events";

const groceryCrudSetQuickSearchValue = (columnName, searchValue) => {
  publishEvent(EVENT_SET_QUICK_SEARCH_VALUE, {
    columnName,
    searchValue,
  });
};

if (window) {
  // Also make it available globally
  window.groceryCrudSetQuickSearchValue = groceryCrudSetQuickSearchValue;
}

export default groceryCrudSetQuickSearchValue;
